import React from 'react';
import PropTypes from 'prop-types';

function IconAdd({ size = 24, color = `#F0F0F0`, className }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.2857 10.9286C13.1674 10.9286 13.0714 10.8326 13.0714 10.7143V6H10.9286V10.7143C10.9286 10.8326 10.8326 10.9286 10.7143 10.9286H6V13.0714H10.7143C10.8326 13.0714 10.9286 13.1674 10.9286 13.2857V18H13.0714V13.2857C13.0714 13.1674 13.1674 13.0714 13.2857 13.0714H18V10.9286H13.2857Z" fill={color}/>    
    </svg>
  )
}

IconAdd.propTypes = {
  size: PropTypes.number.isRequired,
  color: PropTypes.string,
  className: PropTypes.string
}

export default IconAdd;
